/** The shared phone breakpoint; matches Tailwind `max-sm:`. */
export const MELA_PHONE_QUERY = "(max-width: 639.98px)";
export const MELA_PHONE_MEDIA = `@media ${MELA_PHONE_QUERY}`;

/** Phone action row: buttons share the row and wrap instead of clipping their labels. */
export const MELA_PHONE_ACTIONS_ROW = {
  flexWrap: "wrap",
  "--mela-button-min-width": "fit-content",
  "& > *": {
    flex: "1 1 0",
    minWidth: "fit-content",
  },
} as const;
